import {
    LoadPayRelatedAccount,
    RelatedAccountsSource,
    RelatedDeltaClient,
    RelatedOriginationsApplicant,
} from '../../Applicant.types';
import { ApplicantRelatedAccountsSection } from './ApplicantRelatedAccountsSection';
import { CardStack } from '../../Applicant.StyledComponents';
import { RELATED_ACCOUNTS_SOURCES } from './constants';
import { DeltaClientsSection } from './DeltaClientsSection';
import { OriginationsApplicantsSection } from './OriginationsApplicantsSection';

export const ApplicantRelatedAccounts = ({
    loadPayAccounts,
    originationsApplicants,
    deltaClients = [],
    unavailableSources = [],
    isLoading,
    isLoadingError = false,
    onRetry,
}: {
    loadPayAccounts: LoadPayRelatedAccount[];
    originationsApplicants: RelatedOriginationsApplicant[];
    deltaClients?: RelatedDeltaClient[];
    unavailableSources?: RelatedAccountsSource[];
    isLoading: boolean;
    isLoadingError?: boolean;
    onRetry?: () => void;
}) => {
    const isSourceUnavailable = (source: RelatedAccountsSource) =>
        isLoadingError || unavailableSources.includes(source);

    return (
        <CardStack>
            <ApplicantRelatedAccountsSection
                accountsType="LoadPay"
                accounts={loadPayAccounts}
                isLoading={isLoading}
                isLoadingError={isSourceUnavailable(RELATED_ACCOUNTS_SOURCES.LOAD_PAY)}
                onRetry={onRetry}
            />
            <OriginationsApplicantsSection
                accountsType="Originations"
                accounts={originationsApplicants}
                isLoading={isLoading}
                isLoadingError={isSourceUnavailable(RELATED_ACCOUNTS_SOURCES.ORIGINATIONS)}
                onRetry={onRetry}
            />
            <DeltaClientsSection
                accountsType="Delta"
                accounts={deltaClients}
                isLoading={isLoading}
                isLoadingError={isSourceUnavailable(RELATED_ACCOUNTS_SOURCES.DELTA)}
                onRetry={onRetry}
            />
        </CardStack>
    );
};
